// extracted by mini-css-extract-plugin
export default {"myModal":"MyModule_myModal__rsIeb","myModalContent":"MyModule_myModalContent__Vm1B6","active":"MyModule_active__Buumu"};